import { gql } from "@apollo/client";

const schema = {
  create: {
    name: "createOrderAttachment",
    serviceName: "auth",
    query: gql`
      mutation createOrderAttachment(
        $order_id: String!
        $lab_id: String
        $unit_id: String
        $title: String
        $price: String
        $number: String
        $details: String
      ) {
        createOrderAttachment(
          order_id: $order_id
          lab_id: $lab_id
          unit_id: $unit_id
          title: $title
          price: $price
          number: $number
          details: $details
        ) {
          messages
        }
      }
    `,
  },
};

export default schema;
